import { HttpLib } from './http-lib';
import { concat, isEmpty } from 'ramda';
import * as querystring from 'qs';
import { MODIFICATION_URL } from '../../modules/booking/services/booking-service';
import { CacheStrategy } from './cache-strategy';
import { HttpCache } from './http-cache';

import router from '../../router';
import store from '../../store';
import { SET_LOGIN_REDIRECT_ROUTE } from '../../store/app/types';
import { isValidRedirectionRoute } from '../authentication.service';
import { isForbiddenError } from '../../utility';
import { mergeDeepLeft } from 'ramda';
import { toPairs } from 'ramda';
import { mergeAll } from 'ramda';

const REQUEST_CANCELLED = 'REQUEST_CANCELLED';

export let baseUrl = process.env.VUE_APP_BASE_URL;
export let clientName = process.env.VUE_APP_CLIENTNAME;

// export const baseUrl = 'https://staging.detailsdetails.eu';


export const isDev = () => {
  return location.origin === 'https://dev.berlin3.com';
}

export const isAppDetailsDetails = () => {
  return location.origin === 'https://app.detailsdetails.eu';
}

function assignBaseUrl() {


  if (/(localhost)|(192.168)/.test(location.origin)) {
    baseUrl = process.env.VUE_APP_BASE_URL;
    // console.log(`Setting Base URL to default (${baseUrl})`);
  }
  else {
    baseUrl = `${location.origin}`;
    console.log(`Setting Base URL to ${baseUrl}`)
  }

  let clientRe = (new RegExp(`/(.*)/v2/`, 'i')).exec(location.pathname);
  if (clientRe?.[1]) {
    clientName = clientRe?.[1];
  }

  /** Redirection
  //#region Redirection

  // Frontend Redirection to app.details.eu

  if (isDev() && ![
    "updatecheck2", "designcheck", "big_fat_demo_agency", "berlin3", "updatecheck3", "nonreg", "painsurprises", "kuroneko_editest"
  ].includes(clientName)) {
    // Redirect to app.details.eu instead
    window.location.href = `https://app.details.eu${location.pathname}`;
  }


  // Frontend Redirection for Clients from detailsdetails.eu to details.eu

  if (isAppDetailsDetails() && [
    "h33agency",
    "bassgefluester",
    "kromantiagency",
    "sinusagency",
    "solidam",
    "cityslang",
    "mutingthenoise",
    "inouie",
    "kompakt",
    "sonarkollektiv",
    "nuclear_blast",
    "kuroneko",
  ].includes(clientName)) {
    // Redirect to app.details.eu instead
    window.location.href = `https://app.details.eu${location.pathname}${location.search}${location.hash}`;
  }

  //#endregion Redirection
   */

}
assignBaseUrl();

// export let clientName = process.env.VUE_APP_CLIENTNAME;

// const assignClientId = () => {
//   const clientResult = /\/(.*)\/v2\//i.exec(window.location.pathname);
//   if (clientResult && clientResult[1]) {
//     clientName = clientResult[1];
//     console.log(`Client ID - ${clientName}`);
//   }
// };

// assignClientId();

export const isStaging = () => {
  return location.origin == 'https://staging.berlin3.com';
}
export const isLocal = () => {
  return /(localhost)|(192.168)/.test(location.origin);
}

export const isDevOrLocal = () => isDev() || isLocal();

export const fullBaseUrl = `https://staging.detailsdetails.eu/berlin3`;
export const batchServer = `https://batch.berlin3.com`;
export const getBaseUrl = () => `${baseUrl}/${clientName}`;
export const withBaseUrl = concat(`${baseUrl}/${clientName}`)
export const MAIN_STRING = 'main';
export const JSON_STRING = 'json';

export const getBaseURLObject = () => {
  const url = new URL(getBaseUrl());
  const domain_tld = url.hostname.split('.').slice(1).join('.');
  const subdomain = url.hostname.split('.')[0];
  const client_name = clientName;

  return {
    protocol: url.protocol,
    domain_tld,
    subdomain,
    client_name,
  }
}
// From BaseURL Object to BaseURL String
export const getBaseURLString = (baseURLObject) => {
  const { protocol, domain_tld, subdomain } = baseURLObject;
  return `${protocol}//${subdomain}.${domain_tld}`;
}


export const createHttpGetOptions = ({
  cacheStrategy = CacheStrategy.REQUEST_FIRST,
  cancelToken = undefined,
  noJsonOutput = false,
  responseType = 'json',
  qsStringifyArrayFormat = undefined,
  onUploadProgress = undefined,
  withCredentials = true,
  subdomain = undefined,
} = {}) => {
  // cacheStrategy = CacheStrategy.REQUEST_FIRST,
  // cancelToken = undefined,
  // noJsonOutput = false,
  // responseType = 'json',
  // qsStringifyArrayFormat = undefined,
  // onUploadProgress = undefined,
  // withCredentials = true,

  // if (!cacheStrategy) {
  //   cacheStrategy = CacheStrategy.REQUEST_FIRST;
  // }
  // if (!noJsonOutput) {
  //   noJsonOutput = false;
  // }

  // if (!withCredentials) {
  //   withCredentials = true;
  // }

  if (process.env == 'production') {
    cacheStrategy = CacheStrategy.REQUEST_FIRST;
  }
  if (qsStringifyArrayFormat === true) {
    qsStringifyArrayFormat = 'repeat';
  }
  return {
    cacheStrategy,
    cancelToken,
    noJsonOutput,
    responseType,
    qsStringifyArrayFormat,
    onUploadProgress,
    withCredentials,
    subdomain
  }
};


// AXIOS interceptor

const responseInterceptor = HttpLib.interceptors.response.use((response) => {
  // console.warn(response);
  return response;
}, (error) => {
  // console.log(HttpLib.interceptors);

  console.log('REJECTED', error, error.message);

  switch (error.message) {
    case 'Request failed with status code 403': {
      console.log('403 FORBIDDEN');
      console.error(router.currentRoute);

      // This work is moved to InitMainRoute rather than Every Interceptor
      // Might cause problem Later
      // TODO: Recheck With Permission System

      // if (isValidRedirectionRoute(router.currentRoute.name)) {
      //   store.dispatch(SET_LOGIN_REDIRECT_ROUTE, router.currentRoute);
      // }

      if (router.currentRoute.name !== 'mainLogin') {
        router.push({ name: 'mainLogin' });
      }


      break;
    }

    default: {
      console.log('Error - No Redirect');
    }
  }
  return Promise.reject(error);
});


/**
 * @description Returns the raw HTTP result
 * @param {*} ul
 * @param {*} params
 */
const get = async (ul = '', params = {}, options = createHttpGetOptions()) => {
  // let url = `${baseUrl}/${clientId}` + ul;

  // if (isEmpty(params)) {
  //   throw Error(`Params can't be empty`);
  // }

  // if (!params.output && !options.noJsonOutput) {
  //   params.output = JSON_STRING;
  // }

  // const stringifyParams = options.qsStringifyArrayFormat ? querystring.stringify(params, { arrayFormat: "repeat" }) : querystring.stringify(params);
  // const finalURL = `${url}?${stringifyParams}`;

  const finalURL = getFinalURL(ul, params, options);

  // if (options.cacheStrategy === CacheStrategy.CACHE_FIRST) {

  //   const cacheData = await HttpCache.get(finalURL);
  //   if (cacheData) {
  //     return cacheData;
  //   }

  // }

  return HttpLib.get(finalURL, {
    withCredentials: options.withCredentials,
    cancelToken: options.cancelToken,
    responseType: options.responseType
  }).then(res => {

    // if (options.cahceStrategy !== CacheStrategy.REQUEST_ONLY) {

    // HttpCache.save(finalURL, { data: res.data });

    // }

    return res;
  })
    .catch(errorHandler)
    ;
};

const getFinalURL = (ul = '', params = {}, options = createHttpGetOptions()) => {
  let url = `${baseUrl}/${clientName}` + ul;

  if (isEmpty(params)) {
    throw Error(`Params can't be empty`);
  }

  if (!params.output && !options.noJsonOutput) {
    params.output = JSON_STRING;
  }

  const stringifyParams = options.qsStringifyArrayFormat ? querystring.stringify(params, { arrayFormat: options.qsStringifyArrayFormat }) : querystring.stringify(params);
  // console.log("Log: getFinalURL -> stringifyParams", options, options.qsStringifyArrayFormat)

  return `${url}?${stringifyParams}`;
}

/**
 * @description JSON parse only the data and returns it
 * @param {*} ul
 * @param {*} params
 */
const get2 = async (ul = '', params = {}, options = createHttpGetOptions()) => {
  let newBaseUrl = baseUrl;
  if (options.subdomain) {
    newBaseUrl = getBaseURLString({
      ...getBaseURLObject(),
      subdomain: options.subdomain,
    })
    console.log({ 'http-client.js:253 baseUrl': newBaseUrl });
  }

  let url = `${newBaseUrl}/${clientName}` + ul;

  if (isEmpty(params)) {
    throw Error(`Params can't be empty`);
  }

  if (!params.output) {
    params.output = JSON_STRING;
  }

  const finalURL = `${url}?${querystring.stringify(params)}`;

  // if (options.cacheStrategy === CacheStrategy.CACHE_FIRST) {

  //   const cacheData = await HttpCache.get(finalURL);
  //   if (cacheData) {
  //     return cacheData;
  //   }

  // }

  return HttpLib.get(finalURL, {
    withCredentials: true,
    cancelToken: options.cancelToken,
    responseType: options.responseType
  }).then(res => {
    // if (options.cahceStrategy !== CacheStrategy.REQUEST_ONLY) {

    //   HttpCache.save(finalURL, res.data);

    // }
    return res.data;
  })
    .catch(errorHandler);
};

const get3 = async (ul = '', params = {}, options = createHttpGetOptions()) => {
  let url = `${baseUrl}/${clientName}` + ul;

  const finalURL = `${url}${!isEmpty(params) ? `?${querystring.stringify(params)}` : ''}`;

  // if (options.cacheStrategy === CacheStrategy.CACHE_FIRST) {

  //   const cacheData = await HttpCache.get(finalURL);
  //   if (cacheData) {
  //     return cacheData;
  //   }

  // }

  return HttpLib.get(finalURL, {
    withCredentials: true,
    cancelToken: options.cancelToken
  }).then(res => {
    // if (options.cahceStrategy !== CacheStrategy.REQUEST_ONLY) {

    //   HttpCache.save(finalURL, res.data);

    // }
    return res.data;
  })
    .catch(errorHandler);
};

const post = async (url, data, options = createHttpGetOptions()) => {

  let newBaseUrl = baseUrl;
  if (options.subdomain) {
    newBaseUrl = getBaseURLString({
      ...getBaseURLObject(),
      subdomain: options.subdomain,
    })
  }

  const requestKey = `${url}?${querystring.stringify(data)}`;


  return HttpLib.post(`${newBaseUrl}/${clientName}` + url, querystring.stringify(data, { arrayFormat: 'brackets' }), {
    withCredentials: true,
    cancelToken: options.cancelToken
  })
    .then(res => {

      return res;
    })
    .catch(errorHandler);

};
const post2 = async (url, data, options = createHttpGetOptions()) => {
  const requestKey = `${url}?${querystring.stringify(data)}`;

  return HttpLib.post(`${baseUrl}/${clientName}` + url, querystring.stringify(data, { arrayFormat: 'brackets' }), {
    withCredentials: true,
    cancelToken: options.cancelToken
  })
    .then(res => {
      return res.data;
    })
    .catch(errorHandler);
};


const postFormData = (url, formData, postOptions) => {
  // console.log(querystring.stringify(data));
  const { onUploadProgress } = postOptions || {};
  let options = createHttpGetOptions()
  return HttpLib.post(`${baseUrl}/${clientName}` + url, formData, {
    withCredentials: true,
    cancelToken: options.cancelToken,

    responseType: options.responseType,
    onUploadProgress: onUploadProgress
  });
};


/** Convert the Normal JSON object to a Type of FormData */
export const jsonToFormData = (obj) => {
  const formData = new FormData();
  for (let key in obj) {
    formData.append(key, obj[key]);
  }
  return formData;
}

/** Pass in a normal JSON object -> This method will convert the Object to a FormData and then post it to the API */
export const postJSONasFormData = (url, jsonOBJ, options = createHttpGetOptions()) => {
  const formData = jsonToFormData(jsonOBJ);
  return HttpLib.post(`${baseUrl}/${clientName}` + url, formData, {
    withCredentials: true,
    cancelToken: options.cancelToken,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    responseType: options.responseType,
    onUploadProgress: options.onUploadProgress
  });
};

/** Post request to Details Modification API */
const modify = (key, kVal, name, value, table, modified = new Date()) => {
  return post(MODIFICATION_URL, {
    key,
    kVal,
    name,
    value,
    table,
    modified: modified.toISOString()
  }).then(res => {
    return res.data;
  }).catch(err => {
    console.log('Error Occurred', err);
  });
};

/** Post request to Details Modification API with JSON_OP and JSON_KEY */
const modifyJSON = (key, kVal, name, value, table, modified = new Date(), modify_type = '', json_op = '', json_key = '') => {
  return post(MODIFICATION_URL, {
    key,
    kVal,
    name,
    value,
    table,
    modified: modified.toISOString(),
    modify_type,
    json_op,
    json_key,
  }).then(res => {
    return res.data;
  }).catch(err => {
    console.log('Error Occurred', err);
  });
};

/** Post request to Details Record Modification API */

const modifyRecord = ({
  data,
  kVal,
}) => post(MODIFICATION_URL, {
  action: 'modify',
  modify_type: 'record',
  table: 'custom_data',
  data,
  kVal,
})


const errorHandler = e => {
  console.log(e.message);
  if (
    HttpLib.isCancel(e) ||
    isForbiddenError(e)
  ) {
    throw e;
  } else {

  }
};


/** Awaits all the Requests and then Merges the responses. */
const mergeRequests = async (promises = [], logFunction) => {
  const responses = await Promise.all([
    ...promises
  ]);

  return responses.reduce((accm, cur) => {
    accm = mergeDeepLeft(accm, cur.data);
    // if (logFunction) {
    //   logFunction(accm, cur)
    // }
    return accm;
  }, {});
}

/** Awaits all the Requests and then Merges the responses. */
const mergePromiseDict = async (promiseDict = {}) => {
  const responses = await Promise.all(
    toPairs(promiseDict).map(([key, promise]) => {
      // console.log(key);
      return promise.then(res => {
        return { [key]: res }
      })
    })
  );

  // console.log(responses);

  return mergeAll(responses);
}

export const HttpClient = {
  get,
  getFinalURL,
  get2,
  get3,
  post,
  post2,
  postFormData,
  modify,
  modifyJSON,
  modifyRecord,
  getBaseUrl,
  getBaseURLObject,
  mergeRequests,
  mergePromiseDict,
  postJSONasFormData,

  baseUrl,
  clientName,

  getClientName: () => {
    return clientName;
  }
};

export const MHTTPCL = HttpClient;

window.HttpClient = HttpClient;
window.HttpLib = HttpLib;
window.querystring = querystring;
